import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const SpellCheckIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="M3 11l4-8 4 8" />
    <path d="M4.5 7.5h5" />
    <path d="M14 11l2 2 4-5" />
  </Icon>
)
